import clsx from "clsx";

const toneMap = {
    success: "admin-badge-success",
    warning: "admin-badge-warning",
    danger: "admin-badge-danger",
    neutral: "admin-badge-neutral",
};

export const StatusBadge = ({children, tone = "neutral"}) => (
    <span className={clsx("admin-badge", toneMap[tone] || toneMap.neutral)}>{children || "—"}</span>
);
